import { TrungTuyenService } from "../services/trungtuyen.service";
var trungtuyen = {
	trungTuyenId: null,
	createdTime: null,
	createdBy: null,
	modifiedTime: null,
	modifiedBy: null,
	dotDangKyThiSinhId: null,
	sbd: null,
	hoTen: null,
	ngaySinh: null,
	gioiTinh: null,
	soCmnd: null,
	dienThoai: null,
	email: null,
	danToc: null,
	doiTuong: null,
	khuVuc: null,
	diaChi: null,
	truongId: null,
	nganhId: null,
	toHopId: null,
	diem1: null,
	diem2: null,
	diem3: null,
	tongDiem: null,
	tieuChiPhu: null,
	thuTuNv: null,
	type: null,
	status: null,
	dotDangKyThiSinh: null,
	nganh: null,
	maSinhVien: null,
};
var fileDinhKem = {
	fileAnh46: null,
	fileBangTotNghiep: null,
	fileKetQuaThi: null,
}
var state = {
	trungtuyen: { ...trungtuyen },
	nganh: {},
	kinhphinhaphoc: {},
	tohop: {},
	step: 1,
	thisinhs: [],
	fileDinhKem: { ...fileDinhKem },
	sinhvien: {},
	thisinh: {}
};

var getters = {};

var mutations = {
	nextStep(state) {
		state.step = state.step + 1;
	},

	findThiSinhTTHocBa(state, data) {
		state.trungtuyen = data.trungTuyen;
		state.trungtuyen.ngaySinh = formatDate(data.trungTuyen.ngaySinh);
		state.kinhphinhaphoc = data.kinhPhiNhapHoc;
		state.tohop = data.toHop;
		state.nganh = data.nganh;
	},

	findThiSinhTTTHPT(state, data) {
		state.trungtuyen = data.trungTuyen;
		state.trungtuyen.ngaySinh = formatDate(data.trungTuyen.ngaySinh);
		state.kinhphinhaphoc = data.kinhPhiNhapHoc;
		state.tohop = data.toHop;
		state.nganh = data.nganh;
	},

	traCuu(state, data) {
		state.thisinhs = data;
	},

	updateThiSinh(state, data) {
		state.thisinh = data;
	},

	loadNewTrungTuyens(state) {
		state.thisinhs = [];
	},

	loadNewThiSinh(state) {
		state.thisinh = { ...trungtuyen };
	},

	newStep(state) {
		state.step = 1;
	},
	saveSinhVien(state, payload) {
		state.sinhvien = { ...payload };
	}
};

var actions = {
	findThiSinhTTHocBa({ commit }, payload) {
		return TrungTuyenService.findThiSinhTTHocBa(payload)
			.then(async (response) => {
				if (response.status === 200) {
					commit("findThiSinhTTHocBa", response.data);
				}
				return response;
			})
			.catch((error) => error.message);
	},

	findThiSinhTTTHPT({ commit }, payload) {
		return TrungTuyenService.findThiSinhTTTHPT(payload)
			.then(async (response) => {
				if (response.status === 200) {
					commit("findThiSinhTTTHPT", response.data);
				}
				return response;
			})
			.catch((error) => error.message);
	},

	traCuu({ commit }, soCmnd) {
		return TrungTuyenService.traCuu(soCmnd)
			.then((response) => {
				if (response.status == 200) commit("traCuu", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	async updateThongTin({ commit }, payload) {
		return await TrungTuyenService.updateThongTin(payload)
			.then((response) => {
				if (response.status === 201) commit("saveSinhVien", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

let formatDate = (date) => {
	let d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day].join("-");
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
